module.exports = __webpack_public_path__ + "img/transaction.09a6085b.svg";